import { thunk } from 'easy-peasy';
import { IThunkCheckAuthorization } from '../types';

// @ts-ignore
const onCheckAuthorization: IThunkCheckAuthorization = thunk(async ({ setAuthorized }) => {
  setAuthorized();
});

export default onCheckAuthorization;
